import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  padding: var(--sectionSpacing) 0;
  background-color: ${brand.beige};
`;
const Items = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${fluid(16, 36)};
`;
const CategoryCardsStyles = {
    Container,
    Items,
};
export default CategoryCardsStyles;
